import * as Sentry from '@sentry/browser';

import { config } from 'src/config/config';
import { toastNotificationsService } from 'src/config/rootService';

export const addToCalendar = (sessionUuid: string, target: string = '_self') => {
    if (!sessionUuid) {
        Sentry.captureException(new Error('[addToCalendar] sessionUuid parameter not passed'));

        toastNotificationsService.renderErrorToast(config.messages.genericError);
        return;
    }

    window.open(`${config.apiAddress}providers/visits_calendar/${sessionUuid}.ics`, target);
};
